import request from '@/utils/request'

export function submitMessage(data) {
    return request({
      url: '/user/submitMessage',
      method: 'post',
      data
    })
  }
  